module.exports = __webpack_public_path__ + "img/tpc-8.78393480.jpg";